<template>
  <q-page class="column">
    <EnunciadoTable
      :rows="enunciados"
      v-model:pagination="pagination"
      @del="excluirEnunciado"
      @request="fetchEnunciadoTablePage"
    />
  </q-page>
</template>

<script setup>
import EnunciadoTable from "@/components/enunciado/EnunciadoTable.vue";
import {
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS
} from "@/DemandasRepetitivas";
import { useAppStore } from "@/store/app-store";
import { useEnunciadoStore } from "@/store/enunciado-store";
import { useQuasar } from "quasar";
import { computed, watch, ref } from "vue";
EnunciadoTable;

const quasar = useQuasar();
const enunciadoStore = useEnunciadoStore();
enunciadoStore.fetchPage(1, 10);
const appStore = useAppStore();
appStore.drawerExpanded = true

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  get rowsNumber() {
    return enunciadoCount.value;
  },
  set rowsNumber(v) {
    enunciadoCount.value = v;
  }
});

const enunciadoCount = computed(() => enunciadoStore.temasCount);
const currentPage = computed(() => pagination.value?.page);
watch(enunciadoCount, () => (pagination.value.rowsNumber = enunciadoCount.value));
watch(currentPage, () => (enunciadoStore.page = currentPage.value));

const enunciados = computed(() => enunciadoStore.pages[pagination.value.page]);

const fetchEnunciadoTablePage = props => {
  Object.assign(pagination.value, props.pagination);
  props.pagination.rowsPerPage = props.pagination.rowsPerPage == 0 ? enunciadoCount.value : props.pagination.rowsPerPage;
  fetchEnunciadosPage(props.pagination.page, props.pagination.rowsPerPage);
};

const search = () => fetchEnunciadosPage(1);
const fetchEnunciadosPage = (page = 1, rowsPerPage = 10) => enunciadoStore.fetchPage(page, rowsPerPage);

const excluirEnunciado = id => {
  const reload = search;
  const failure = () => notify(DELETE_FAILURE, "negative");
  const success = () => notify(DELETE_SUCCESS, "positive");

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`enunciado/${id}`)
    .then(readResponse)
    .catch(failure);
};

const notify = (msg, color) => {
  const notifyObj = (message, color) => ({ message, color });
  quasar.notify(notifyObj(msg, color));
};
</script>
